import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Accordian = ({ panels }: { panels: any[] }) => {
    return (
        <>
            {panels.map((p: { top: string, bottom: string }, i: number) => (
                <Accordion
                    key={"panel" + i}
                    style={{ backgroundColor: "rgba(100,100,100,0.05)" }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="body1">{p.top}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">{p.bottom}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </>
    );
};

export default Accordian;